import * as React from 'react';

import classnames from 'classnames';

import type {User, InstanceInfo} from 'nutshell-graphql-types';

import {initializeEmbeddedNsFormById} from '../../../../../util/initialize-embedded-ns-form-by-id';
import type {DefaultValues} from '../../../../../util/initialize-embedded-ns-form-by-id';
import {useGetInstanceInfo} from '../../../../core/use-get-instance-info';
import {useGetSessionUser} from '../../../../core/use-get-session-user';

import styles from './custom-quote.module.css';

export function CustomQuote() {
    const FORM_ID = 'LApYuQ';

    // Get user and instance info to prefill form
    const {user} = useGetSessionUser();
    const {sessionInstance} = useGetInstanceInfo();

    React.useEffect(() => {
        const defaultValues = getDefaultValues(user, sessionInstance);
        initializeEmbeddedNsFormById(FORM_ID, defaultValues);
    }, [user, sessionInstance]);

    return (
        <div className={styles.container}>
            <div className={styles['masthead-content']}>
                <h1
                    className={classnames(
                        styles['masthead-maintitle'],
                        styles['masthead-maintitle-medium']
                    )}
                >
                    Get a custom quote
                </h1>
                <div className={styles['masthead-description']}>
                    <span>
                        The first step in getting a quote for a custom integration is a discovery
                        call with our team. Fill out the form below and we will be in touch.
                    </span>
                </div>
            </div>
            <div className={styles['typical-costs']}>
                <h2>Typical costs</h2>
                <ul>
                    <li className={styles.item}>
                        For products that might involve a one-way sync, our Custom Data Pipeline
                        services start at $800.
                    </li>
                    <li className={styles.item}>
                        For custom software that might involve two-way data flows or connections to
                        custom APIs, services start at $2,900.
                    </li>
                </ul>
            </div>
            <div id={`nutshell-form-${FORM_ID}`} className={styles['form-container']} />
        </div>
    );
}

function getDefaultValues(
    user?: User | null,
    sessionInstance?: InstanceInfo | null
): DefaultValues {
    const defaultValues: DefaultValues = {};

    if (user) {
        defaultValues.name = user.name;
        // @ts-expect-error
        defaultValues.email = user.emailAddresses.length > 0 ? user.emailAddresses[0].address : '';
    }

    if (sessionInstance) {
        defaultValues.companyName = sessionInstance.companyName;
    }

    return defaultValues;
}
